import { IRewardsAllocation } from "./rewardsAllocation";
import { RewardsAccount } from "redmond";

export interface IMultiRewardsAccountUsed {
  product: string;
  currency: string;
  amount_usd: number;
}

export interface IMultiRewardsTrackingSummary {
  totalRewardsAmountUsd: number;
  rewardsProductUsed: string;
  rewardsCurrency: string;
  multiRewardsAccountsUsed: IMultiRewardsAccountUsed[];
}

export const resolveMultiRewardsTrackingSummary = (
  allocations: IRewardsAllocation[],
  rewardsAccounts: RewardsAccount[]
): IMultiRewardsTrackingSummary => {
  const multiRewardsAccountsUsed: IMultiRewardsAccountUsed[] = allocations
    .filter((allocation) => allocation.fiat.value > 0)
    .map((allocation) => {
      const account = rewardsAccounts.find(
        (rewardsAccount) =>
          rewardsAccount.accountReferenceId === allocation.accountReferenceId
      );
      return {
        product: account?.productDisplayName ?? "",
        currency: allocation.rewards.currency,
        amount_usd: allocation.fiat.value,
      };
    });

  const primaryAccount = multiRewardsAccountsUsed.length
    ? multiRewardsAccountsUsed.reduce((largest, current) =>
        current.amount_usd > largest.amount_usd ? current : largest
      )
    : undefined;

  return {
    totalRewardsAmountUsd: multiRewardsAccountsUsed.reduce(
      (sum, account) => sum + account.amount_usd,
      0
    ),
    rewardsProductUsed: primaryAccount?.product ?? "",
    rewardsCurrency: primaryAccount?.currency ?? "",
    multiRewardsAccountsUsed,
  };
};
